//import Notification from '../notification/notification';
export default new class AuthReg {
  constructor() {
    this.openModal          = 'custom-modal';
    this.modalId            = 'auth_reg';
    this.overlay            = 'overlay';
    this.close              = '.close-modal';
    this.activeClass        = ' _open_modal';
    this.$modalButton       = $(`#${this.openModal}`);
    this.$modal             = $(`#${this.modalId}`);
    this.isCheckEmail       = false;
    this.isCheckPhone       = false;
    this.isCheckSms         = false;
    this.isNeedReloadPage   = false;
    this.isPaidModal        = false;
    this.isPaidModalAssist  = false;
    this.responseData       = '';
    this.redirectUrl        = false;
    this.targetButton       = false;
    this.needUpdated        = false;
    this.countCreated       = 0;
    this.iArticleID = undefined;
    this.checkRequest();
    this.bindEvent();
    this.checkRequest();
    this.showModal();
    this.addAgreeLink($('#i_agree-link'));
    this.addGiveLink($('#i_give-link'));
  }

  checkRequest() {
    if (location.href.includes('login')) {
      this.redirectUrl = decodeURIComponent(location.search.substring(14));
    }
  };

  showModal() {
    if (this.redirectUrl !== false) {
      $('#custom-modal').click();
    }
  };

  bindEvent() {
    $(document).on('click', '#custom-modal, #custom-modal-2, #custom-modal-3, .form-docs', (e) => {
      e.preventDefault();
      this.iArticleID = e.target.getAttribute('data-article-id');

      if (e.target.id === 'custom-modal-3') {
        this.isPaidModal = '/user/';
      } else if (e.target.id === 'custom-modal-2') {
        this.isPaidModalAssist = e.target.id;
      } else if (!e.target.getAttribute('data-redirect')) {
        this.isNeedReloadPage = true;
      } else {
        this.redirectUrl = e.target.getAttribute('data-redirect');
      }
      const tab = $('#custom-modal').attr('data-active-tab');

      $('#auth_reg').addClass(this.activeClass);

      if (tab === 'auth') {
        this.activeAuthTab();
      } else {
        this.activeRegTab();
      }
      // eslint-disable-next-line sonarjs/no-duplicate-string
      $('#tab-sms-container').hide();
      $('#forget-container').hide();

      $('form[name=registration-form]').trigger('reset');
      $('form[name=authentification-form]').trigger('reset');
      $('form[name=forget-form]').trigger('reset');

      if ($('.eye').hasClass('eye show')) {
        $('.eye').removeClass('show').addClass('hide');
        document.querySelector('#password').type = 'password';
      }

      $('#auth_reg').show();
    });

    $(document).on('click', '#tab-auth', (e) => {
      e.preventDefault();
      // eslint-disable-next-line sonarjs/no-duplicate-string
      if (!$('#tab-auth').hasClass('active-tab')) {
        this.activeAuthTab();
      }
    });

    $(document).on('click', '#tab-reg', (e) => {
      e.preventDefault();

      if (!$('#tab-reg').hasClass('active-tab')) {
        this.activeRegTab();
      }
    });

    $(document).on('click', this.close, (e) => {
      e.preventDefault();
      this.hideModal()
    });

    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.hideModal()
      }

      // click по нажатию enter)
      if (e.key === 'Enter' && $('#tab-auth').hasClass('active-tab')) {
        $('.js-login').click();
      } else if (e.key === 'Enter' && $('#tab-reg').hasClass('active-tab')) {
        $('.js-reg').click();
      }

    });

    $(document).on('click', '#overlay', () => {
      this.hideModal()
    });

    $(document).on('click', '.js-reg', (e) => {
      e.preventDefault();
      this.registration(e);
    });

    $(document).on('click', '#account-update', (e) => {
      e.preventDefault();
      this.needUpdated = true;
      this.registration(e);
    });

    $(document).on('focusin', 'input[data-check="email-reg"]', () => {
      $('#message-registration').hide();
      $('#email-message').hide();
      $('#email-check-msg').hide();
    });
    $(document).on('blur', 'input[data-check="email"]', (e) => {
      //this.checkEmailRequest(e.target.value);
      if ($('#email').val()) {
        $('#email-message').hide();
      } else {
        $('#email-message').show();
      }
      if (this.isPhoneValidated($('#email').val())) {
        $('#email-check-msg').hide();
      } else {
        $('#email-check-msg').show();
      }
    });

    $(document).on('blur', 'input[data-check="phone"]', (e) => {
      //this.checkPhoneRequest(e.target.value);
      if ($('#phone').val()) {
        $('#phone-message').hide();
      } else {
        $('#phone-message').show();
      }
      if (this.isPhoneValidated($('#phone').val())) {
        $('#phone-check-msg').hide();
      } else {
        $('#phone-check-msg').show();
      }
    });


    $(document).on('focusin', 'input[data-check="phone-reg"]', () => {
      $('#message-registration').hide();
      $('#phone-message').hide();
      $('#phone-check-msg').hide();
    });

    $(document).on('click', '.js-reg-confirm', (e) => {
      e.preventDefault();
      const smsCode = $('#smscode').val();
      this.submitRegistration(this.regForm, smsCode);
    });
    $(document).on('click', '#sms-code-repeat', (e) => {
      e.preventDefault();
      $.request('CustomRegistration::onSendSMSCode', {
        data: {phone: this.regForm.find('input[data-check="phone"]').val()},
        success: (data) => {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          const message = document.querySelector('#message-error');
          message.innerHTML = '';
          if (!data.status) {
            message.innerHTML = 'При отправки SMS возникла ошибка';
            message.style.color = 'red';
            $('#message-error').show();
            this.isCheckSms = false;
          }
          message.innerHTML = 'Отправлен повторно SMS код';
          message.style.color = 'green';
          $('#message-error').show();
          this.isCheckSms = true;
        },
      });
    });
    $(document).on('click', '#eye', (e) => {
      if ($(e.target).hasClass('eye hide')) {
        $(e.target).removeClass('hide').addClass('show');
        document.querySelectorAll('.password')[0].type = 'text';
        document.querySelectorAll('.password')[1].type = 'text';
      } else if ($(e.target).hasClass('eye show')) {
        $(e.target).removeClass('show').addClass('hide');
        document.querySelectorAll('.password')[0].type = 'password';
        document.querySelectorAll('.password')[1].type = 'password';
      }
    });
    $(document).on('click', '.js-login', (e) => {
      e.preventDefault();
      const $formName = $(e.target).closest('form');
      const email = $formName.find('input[data-check="email-login"]').val();
      if (!email) {
        const message = document.querySelector('#email-login-message');
        message.innerHTML = '';
        message.innerHTML = 'Укажите ваш адрес электронной почты';
        $('#email-login-message').show();
      } else {
        this.submitLogin($formName, this.isPaidModal, this.isPaidModalAssist, this.isNeedReloadPage, this.redirectUrl);
      }
    });
    $(document).on('click', '#forget-me', (e) => {
      e.preventDefault();
      $('#tab-sms-container').hide();
      $('#tab-auth-container').hide();
      $('#tab-reg-container').hide();
      $('#tabs-container').hide();
      $('#forget-container').show();
    });
    $(document).on('click', '#js-forget', (e) => {
      e.preventDefault();
      const $formName = $(e.target).closest('form');
      const email = $formName.find('input[data-check="email-forget"]').val();
      if (!email) {
        const message = document.querySelector('#email-forget-message');
        message.innerHTML = '';
        message.innerHTML = 'Укажите ваш адрес электронной почты';
        $('#email-forget-message').show();
      } else {
        this.restorePassword($formName);
        $('#auth_reg').hide();
      }
    });
    $(document).on('click', '#account-reset', (e) => {
      e.preventDefault();
      const $formName = $(e.target).closest('form');
      const email = $formName.find('input[data-check="email-forget"]').val();
      if (!email) {
        $('#email-check-msg').show();
      }
      $('#email-check-msg').hide();
      this.restorePassword($formName);
      const messageRegistration = document.querySelector('#message-registration');
      messageRegistration.style.color = 'green';
      messageRegistration.innerHTML = ' На указанный email отправлена ссылка для восстановления';
    });
  }

  registration(e) {
    this.isCheckEmail       = false;
    this.isCheckPhone       = false;
    const $formName = $(e.target).closest('form');

    this.regForm = $formName;
    // eslint-disable-next-line sonarjs/no-duplicate-string
    const phone = $formName.find('input[data-check="phone-reg"]').val();
    // eslint-disable-next-line sonarjs/no-duplicate-string
    const email = $formName.find('input[data-check="email-reg"]').val();

    if (!email) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      const message = document.querySelector('#email-message');
      message.innerHTML = '';
      // eslint-disable-next-line sonarjs/no-duplicate-string
      message.innerHTML = 'Укажите ваш адрес электронной почты';
      $('#email-message').show();
    }

    if (!phone) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      const message = document.querySelector('#phone-message');
      message.innerHTML = '';
      message.innerHTML = 'Укажите ваш телефонный номер';
      $('#phone-message').show();
    }

    //checkbox messages
    if (!$('#checkbox-agree').is(':checked')) {
      $('#checkbox-agree-msg').show();
    } else {
      $('#checkbox-agree-msg').hide();
    }
    if (!$('#checkbox-give').is(':checked')) {
      $('#checkbox-give-msg').show();
    } else {
      $('#checkbox-give-msg').hide();
    }

    //    phone Validation
    if(!this.isPhoneValidated($('#phone').val())){
      $('#phone-check-msg').show();
    } else {
      $('#phone-check-msg').hide();
    }

    //    Email Validation
    if(!this.isEmailValidated($('#email').val()) && ($('#email').val() != '')){
      $('#email-check-msg').show();
    } else {
      $('#email-check-msg').hide();
    }

    //    Password Validation
    if(!this.isPasswordValidated($('#password').val())){
      $('#password-check-msg').show();
    } else {
      $('#password-check-msg').hide();
    }

    if (
      $('#checkbox-give').is(':checked') &&
      $('#checkbox-agree').is(':checked') &&
      this.isEmailValidated($('#email').val()) &&
      this.isPhoneValidated($('#phone').val()) &&
      this.isPasswordValidated($('#password').val())
    ){

      this.checkPhoneEmailRequest($('#phone').val(), $('#email').val());
    }
  }

  activeRegTab() {
    $('#tab-reg').addClass('active-tab');
    $('#tab-reg-container').show();
    $('#tab-auth').removeClass('active-tab');
    $('#tabs-container').show();
    $('#tab-auth-container').hide();
    $('#tab-sms-container').hide();
    $('#forget-container').hide();

  }


  activeAuthTab() {
    $('#tab-auth').addClass('active-tab');
    $('#tab-reg').removeClass('active-tab');
    $('#tabs-container').show();
    $('#tab-auth-container').show();
    $('#tab-reg-container').hide();
    $('#tab-sms-container').hide();
    $('#forget-container').hide();
  }

/*  checkEmailRequest(email) {
    $.request('CustomRegistration::onCheckEmail', {
      data: {email},
      success: (data) => {
        if (!data.status) {
          const message = document.querySelector('#email-message');
          message.innerHTML = '';
          message.innerHTML = 'Email занят';
          $('#email-message').show();
          this.isCheckEmail = false;
        } else {
          this.isCheckEmail = true;
        }
      },
    });
  }*/

  checkPhoneEmailRequest(phone, email) {
    $.request('CustomRegistration::onCheckPhoneEmail', {
      data:{ phone, email },
      success: (data) => {
        const messageRegistration = document.querySelector('#message-registration');
        messageRegistration.innerHTML = '';
        messageRegistration.style.color = 'red';
        if (data.data.update === 0 && data.data.email === 1 && data.data.phone === 1 ) {
          messageRegistration.innerHTML = 'Аккаунт с таким email или номером телефона уже существует';
          $('#message-registration').show();
          this.isCheckEmail = false;
          this.isCheckPhone = false;
        } else if (data.data.email === 1 && data.data.phone === 1 && data.data.update === 1) {
          messageRegistration.innerHTML = 'Аккаунт с таким email или номером телефона уже существует. ' +
            'Возможно он Ваш. <div class="btn forget_btn cursor-pointer"  id="account-update">Восстановить аккаунт?</div>';
          $('#message-registration').show();
          this.isCheckEmail = false;
          this.isCheckPhone = false;
        } else if (data.data.email === 0 && data.data.phone === 1 && data.data.update === 1) {
          messageRegistration.innerHTML = 'Аккаунт с таким email или номером телефона уже существует. ' +
            'Возможно он Ваш. <div class="btn forget_btn cursor-pointer"  id="account-update">Восстановить аккаунт?</div>';
          $('#message-registration').show();
          this.isCheckEmail = true;
          this.isCheckPhone = false;
        } else if (data.data.email === 1 && data.data.phone === 0 && data.data.update === 1) {
          messageRegistration.innerHTML = 'Аккаунт с таким email уже существует';
          $('#message-registration').show();
          this.isCheckEmail = false;
          this.isCheckPhone = true;
        } else {
          messageRegistration.innerHTML = '';
          $('#message-registration').hide();
          this.isCheckEmail = true;
          this.isCheckPhone = true;

        }
        if ((this.isCheckEmail && this.isCheckPhone) || this.needUpdated) {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          $.request('CustomRegistration::onSendSMSCode', {
            data: {phone},
            success: (data) => {
              const message = document.querySelector('#phone-message');
              if (!data.status) {
                message.innerHTML = '';
                message.innerHTML = 'Ошибка запроса sms';
                $('#phone-message').show();
                this.isCheckSms = false;
              }
              this.isCheckSms = true;
              $('form[name=confirm-form]').trigger('reset');
              // eslint-disable-next-line sonarjs/no-duplicate-string
              $('#tab-auth-container').hide();
              // eslint-disable-next-line sonarjs/no-duplicate-string
              $('#tab-reg-container').hide();
              // eslint-disable-next-line sonarjs/no-duplicate-string
              $('#tabs-container').hide();
              $('#tab-sms-container').show();
              this.needUpdated = false;
            },
          });
        }
      }
    })
  }

/*  checkPhoneRequest(phone) {
    $.request('CustomRegistration::onCheckPhone', {
      data: {phone},
      success: (data) => {
        if (!data.status) {
          const message = document.querySelector('#phone-message');
          message.innerHTML = '';
          message.innerHTML = 'Пользователь с таким телефонным номером уже зарегистрирован.';
          $('#phone-message').show();
          this.isCheckPhone = false;
        } else {
          this.isCheckPhone = true;
        }
      },
    });
  }*/

  requestSmsCode(phone) {
    $.request('CustomRegistration::onSendSMSCode', {
      data: {phone},
      success: (data) => {
        const message = document.querySelector('#phone-message');
        if (!data.status) {
          message.innerHTML = '';
          message.innerHTML = 'Ошибка запроса sms';
          $('#phone-message').show();
          this.isCheckSms = false;
        }

        this.isCheckSms = true;
      },
    });
  }

  submitRegistration($form, smscode) {
    $form.request('CustomRegistration::onAjax', {
      data: {
        sms_code: smscode
      },
      success: (response) => {
        const message = document.querySelector('#message-error');
        message.innerHTML = '';
        if (!response.status) {
          message.innerHTML = 'При регистрации возникла ошибка';
          message.style.color = 'red';
          $('#message-error').show();
          return;
        }
        message.innerHTML = 'Пользователь успешно зарегистрирован';
        message.style.color = 'green';
        $('#message-error').show();
        this.submitLogin($form, this.isPaidModal, this.isPaidModalAssist, this.isNeedReloadPage, this.redirectUrl);
        $('#auth_reg').hide();
        try {
          yaCounter20830984.reachGoal('newregistration'); // eslint-disable-line no-undef
          ga('send', 'event', 'Form', 'newregistration'); // eslint-disable-line no-undef
        } catch (e) {
        } // eslint-disable-line no-empty
      },
    });
  }

  submitLogin($form, isPaidModal, isPaidModalAssist, isNeedReloadPage, redirectUrl) {
    const iArticleID = this.iArticleID;
    $form.request('Login::onAjax', {
      success(response) {
        if (response.X_OCTOBER_REDIRECT) {
          location.reload();
        }

        if (!response.status && response.message) {
          const message = document.querySelector('#message-auth-error');
          message.innerHTML = response.message;
          message.style.color = 'red';
          $('#message-auth-error').show();
          return;
        }
        try {
          yaCounter20830984.reachGoal('signinbutton'); // eslint-disable-line no-undef
          ga('send', 'event', 'Button', 'signinbutton'); // eslint-disable-line no-undef
        } catch (e) {
        } // eslint-disable-line no-empty
        $('#auth_reg').hide();
        this.responseData = response.data;
        if (iArticleID) {
          $.request('Cart::onCheckAccess', {
            data: {
              iArticle: iArticleID,
            },
            success(responseAccess) {
              if (responseAccess.status) {
                $('#auth_reg').hide();
                $('#auth_reg').removeClass(this.activeClass);
                location.reload();
              } else {
                // redirects
                if (isPaidModal) {
                  if ($('#custom-modal-3').attr('data-redirect') === 'user-services') {
                    location.href = `${isPaidModal}${response.data}` + '/' +
                      $('#custom-modal-3').attr('data-group') +
                      '?article_id=' +  $('#custom-modal-3').attr('data-id');
                  } else {
                    location.href = `${isPaidModal}${response.data}/products`;
                  }
                } else if (isPaidModalAssist) {
                    $('#' + isPaidModalAssist + '').addClass('by-one-article').click();

                } else if (redirectUrl !== '' && redirectUrl !== false && redirectUrl !== undefined) {
                  location.href = redirectUrl;
                } else if (redirectUrl === '' || redirectUrl === false || redirectUrl === undefined) {
                  location.reload();
                }
              }
            }
          })
        } else {
          if (redirectUrl !== '' && redirectUrl !== false && redirectUrl !== undefined) {
            location.href = `/user/${response.data}/`+ redirectUrl;
          }
          location.reload();
        }
        this.success(response);
      },
    });
  }

  restorePassword($form) {
    $form.request('RestorePassword::onAjax', {
      success: (response) => {

      },
    });
  }

  isEmailValidated(email) {
    var EmailRegex = /^([a-zA-Z0-9_.+-])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
    return EmailRegex.test(email);
  }

  isPasswordValidated(password) {
    var PasswordRegex = /^([a-zA-Z0-9]{6,})+$/;
    return PasswordRegex.test(password);
  }

  isPhoneValidated(phone) {
    var PhoneRegex = /\+375 (\(33\)||\(29\)||\(44\)||\(25\)) \d{3}-\d{2}-\d{2}/;
    return PhoneRegex.test(phone);
  }

  addAgreeLink(iAgree) {
    var siteName = location.host.split('.').shift()
    return iAgree.attr('href', location.protocol + '//' + location.host + '/pravila-ispolzovaniya-materialov-i-servisov-portala-www' + siteName);
  }

  addGiveLink(iGive) {
    return iGive.attr('href', location.protocol + '//' + location.host + '/politika-v-otnoshenii-obrabotki-personalnyh-dannyh');
  }

  hideModal() {
    this._hideMessages();
    $('#auth_reg').hide().removeClass(this.activeClass);
  }

  _hideMessages() {
    const messages = document.querySelectorAll('.form-item__error-message');
    if (messages) {
      messages.forEach(message => {
        message.style.display = 'none';
      })
    }
  }

}();
